import { render, staticRenderFns } from "./uploadAcknowledgement.vue?vue&type=template&id=520282d9&scoped=true&lang=html"
import script from "./uploadAcknowledgement.vue?vue&type=script&lang=js"
export * from "./uploadAcknowledgement.vue?vue&type=script&lang=js"
import style0 from "./uploadAcknowledgement.vue?vue&type=style&index=0&id=520282d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520282d9",
  null
  
)

export default component.exports